export function isNonUSEmail(email: string) {

    // Basic email syntax check
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
        //throw new Error("Invalid email format");
        return false;
    }

    // Extract the domain part
    const domainParts = email.split('@')[1].split('.');

    // Get the TLD (the last segment after the last dot)
    const tld = domainParts[domainParts.length - 1].toLowerCase();

    // Common US TLDs
    const usTlds = ['us', 'edu', 'gov', 'mil', 'net', 'com'];

    // Check if the TLD is not in the US list
    return !usTlds.includes(tld);
}

// // Example usage:
// console.log(isNonUSEmail("user@example.co.uk")); // true
// console.log(isNonUSEmail("user@company.us"));   // false
// console.log(isNonUSEmail("user@gmail.com"));    // false
